import { getApiToken } from "../helpers";
import { GenerateCcsPdfRequest, GenerateCcsPdfResponse } from "./protos/messages/pdf.message_pb";
import { getBffRequest } from "./base/api";

/**
 * Generates a CCS PDF for a claim
 * Calls through the BFF (claims_bff_api.ClaimsBFFController/GenerateCcsPdf)
 * @param claimId - The claim ID
 * @param templateId - The template ID to use for PDF generation (optional)
 * @returns Promise<GenerateCcsPdfResponse> containing the PDF URL
 */
export const generateCcsPdf = async (
	claimId: number,
	templateId: string = "default"
): Promise<GenerateCcsPdfResponse> => {
	const token = getApiToken();
	const client = getBffRequest(token);

	const request = new GenerateCcsPdfRequest();
	request.setClaimId(claimId);
	request.setTemplateId(templateId);

	return client.generateCcsPdf(request, { authorization: token });
};
